import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { Baseservice } from 'app/services/baseservice';
import { environment } from 'environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AnnualComplianceService extends Baseservice {
  private reloadSubject: Subject<void> = new Subject<void>();
  protected paygateUrl:string = environment.payGateApi.icbmsUrl;
  protected paySuccessUrl:string = environment.payGateApi.url;
  protected InvoiceUrl:string = environment.iCBMSWebApi.url;
  protected returnUrl:string = environment.payGateApi.returnUrl;
  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('compliance', http, authentication);
   }

   private complianceListSubject = new BehaviorSubject<any>([]);
   private complianceDataStore: {annualList:any} = {annualList:[]}
   readonly annualList = this.complianceListSubject.asObservable();

   private complianceDuplicateSubject = new BehaviorSubject<any>([]);
   private complianceDuplicateDataStore: {annualDuplicateList:any} = {annualDuplicateList:[]}
   readonly annualDuplicateList = this.complianceDuplicateSubject.asObservable();

   downloadpdf(id) {
    return this.http
      .get(this.url + "document/download/" + id, { responseType: "blob" })
      .pipe(
        map((res: any) => {
          return new Blob([res], { type: "application/pdf" });
        })
      );
  }

  //Get Due Compliance Permit list without filters
  getPermitListByCarrierId(carrierId, params) {
    return this.http.get(`${this.url}/getcarrierpermitlist/${carrierId}${params}`);
  }

  //
  getAnnualComplianceDetailsById(id) {
    return this.http.get(`${this.url}/getComplianceByCompId/${id}`);
  }
  getCompliance_AnnualByPermitId(id) {
    return this.http.get(`${this.url}/getCompliance_AnnualByPermitId/${id}`);
  }
  saveCompliance(body) {
    return this.http.put(`${this.url}/update`,body);
    
  }
  //Get Due Compliance Permit list with filters
  getFilteredPermitListByCarrierId(queryParams, body) {
    console.log(`${this.url}${queryParams}`);
    return this.http.post(`${this.url}/certificates/search/${queryParams}`,body);
  }

  //To get eNAtis SARS and CIPC details
  getComplianceStatuses(body) {
    return this.http.post(`${this.url}/compliancestatus`,body);
  }

  getPermitVehicleDetails(id) {
    return this.http.get(`${this.url}/getComplianceCertificatesPaymentScreen/${id}`);
  }

  createCompliancePaymentInvoice(body) {
    return this.http.post(`${this.InvoiceUrl}/compliance/createinvoice`,body);
  }


  payUsingPaygate(body) {
    return this.http.post(`${this.paygateUrl}/transaction/add`,body);
  }

  paymentSuccessPaygate(body) {
    const obj = body;
    obj.RETURN_URL = `${this.returnUrl}${obj.referenceid_carrierId}`;
    delete obj.referenceid_carrierId;
    return this.http.post(`${this.paySuccessUrl}/initiate`,obj);
  } 

  getPermitVehicleDetailsConfimation(id) {

    return this.http.get(`${this.url}/getComplianceCertificatesPaymentScreenConfirmation/${id}`).subscribe(
    (result:any) =>{
      this.complianceDataStore.annualList = result;
      console.log("this the other result",result);
      this.complianceListSubject.next(
      Object.assign({}, this.complianceDataStore).annualList
      )

    }
    );
  }
  
  reloadConfirmationScreen() {
    this.reloadSubject.next();
  }

  getReloadObservable() {
    return this.reloadSubject.asObservable();
  }


  createCompliance(body) {
    return this.http.post(`${this.url}/saveDup`,body);   
  }
  createInvoiceFromComplianceIdsAsync(Ids: number[]) {
    const url = `${this.InvoiceUrl}/compliance/createinvoices`;
   
    
  
    return this.http.post(url, Ids);
  }


  getComplianceCertificatesPaymentScreenForDuplicate(id) {
    return this.http.get(`${this.url}/getComplianceCertificatesPaymentScreenForDuplicate/${id}`);
  }
  getComplianceCertificatesConfirmationScreenForDuplicate(id) {
    return this.http.get(`${this.url}/getComplianceCertificatesPaymentScreenConfirmationForDuplicate/${id}`).subscribe(
      (result:any) =>{
        this.complianceDuplicateDataStore.annualDuplicateList = result;
        console.log("this the other result",result);
        this.complianceDuplicateSubject.next(
        Object.assign({}, this.complianceDuplicateDataStore).annualDuplicateList
        )
  
      }
      );}

      getComplianceConfirmationForDuplicate(Ids: number[]) {
        const url = `${this.url}/getComplianceConfirmationForDuplicate`;
        return this.http.post(url, Ids);
      }
//monthlycomps
searchPermits(params,body){

  return this.http.post(`${this.url}/searchcarrierpermitlist/${params}`,body );
}

      getListMonthlyCompliance(queryParams, body) {
        
        return this.http.post(`${this.url}/listmonthlycompliance/${queryParams}`, body);
    }

      //permit list grid 

      getPermitListByCarrierIdMonthly(carrierId, params) {
        return this.http.get(`${this.url}/getcarrierpermitlistmonthly/${carrierId}${params}`);
    }

  

    getCompliancesAmountsToBePaid(complianceId : number ) {
      return this.http.get(`${this.url}/getCompliancesAmountsToBePaid/${complianceId}`);
    }

    SendEmailWithNoFunds(carrier_id : number , UserName : string) {
      return this.http.get(`${this.url}/SendEmailWithNoFunds/${carrier_id}/${UserName}`);
    }

    UpdateComplianceStatuses(id : number , status : string) {
      return this.http.get(`${this.url}/UpdateComplianceStatuses/${id}/${status}`);
    }

    getCompliancesSelected(complianceIDs) {
      return this.http.get(`${this.url}/getCompliancesSelected/${complianceIDs}`);
    }

    getCompliancesSelectedDuplicate(complianceIDs) {
      return this.http.get(`${this.url}/getCompliancesSelectedDuplicate/${complianceIDs}`);
    }

  }
  


